import * as Yup from 'yup';
import { yupToFormErrors } from 'formik';

const ElogSchema = Yup.object().shape({
    companyId: Yup.string()
        .required('Company is required.'),
    nric: Yup.string()
        .required('Patient is required.'),
    hospital: Yup.string()
        .required('Hospital is required.'),
    diagnosis: Yup.string()
        .required('Diagnosis is required.'),
    descriptionOfSymptoms: Yup.string()
        .trim()
        .required('Symptoms is required.'),
    dateTheSymptomsStarted: Yup.date()
        .required('Date is required.'),
    dateFrom: Yup.date()
        .required('Date is required.'),
});

export default ElogSchema;
